/**
 * A class that queries against the VTWA Subjects API
 */
export default class SearchSubjects {
  resetAbortController() {
    if(window.AbortController) {
      this.abortController && this.abortController.abort();
      this.abortController = new AbortController();
    }
  }

  /**
   * Performs a fetch against the VTWA Subjects API for the given query.
   * @param {String} query - The string to query
   * @returns {Promise} - Promise containing the results as { type, text, href }
   */
  async search(query) {
    this.resetAbortController();

    return fetch(
      `https://${process.env.API_HOST}/vtwa/v1/subjects/lookup?query=${encodeURIComponent(query)}`,
      {
        signal: this.abortController && this.abortController.signal
      }
    ).then(response => response.json()).then((results) => (
      results.map((result) => (
        { type: 'subject', text: result.display_name, href: `/${result.short_name}-tutors` }
      ))
    ));
  }
}
